import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SidebarLink from './SidebarLink';
import SidebarOutLink from './SidebarOutLink';
import SidebarCategory from './SidebarCategory';

class SidebarContent extends Component {
  static propTypes = {
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    changeToSystem: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    profile: PropTypes.shape({
      privileges: PropTypes.arrayOf(PropTypes.string),
    }),
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };

  render() {
    const {
      changeToDark,
      changeToLight,
      changeToSystem,
      profile
    } = this.props;
    const hasApiAccess = Array.isArray(profile?.privileges) && profile.privileges.includes('API_ACCESS');
    const hasServerManagement = Array.isArray(profile?.privileges) && (
      profile.privileges.includes('GAME_SERVER_RESTART') || profile.privileges.includes('GAME_SOURCE_MANAGE')
    );
    return (
      <div className="sidebar__content">
        <ul className="sidebar__block">
          {/*<SidebarLink title="Log In" icon="exit" route="/log_in" onClick={this.hideSidebar}/>*/}
          <SidebarCategory title="테마" icon="layers">
            <button type="button" className="sidebar__link" onClick={changeToSystem}>
              <p className="sidebar__link-title">시스템 설정</p>
            </button>
            <button type="button" className="sidebar__link" onClick={changeToDark}>
              <p className="sidebar__link-title">어두운 테마</p>
            </button>
            <button type="button" className="sidebar__link" onClick={changeToLight}>
              <p className="sidebar__link-title">밝은 테마</p>
            </button>
          </SidebarCategory>
        </ul>
        <ul className="sidebar__block">
          <SidebarCategory title="서비스 이용 내역" icon="list">
            <SidebarLink title="접속 내역" icon="enter" route="/connection-logs" isSubMenu="true" onClick={this.hideSidebar}/>
            <SidebarLink title="정책 위반 내역" icon="warning" route="/suspicion-logs" isSubMenu="true" onClick={this.hideSidebar}/>
            <SidebarLink title="서비스 이용 내역" icon="list" route="/service-logs" isSubMenu="true" onClick={this.hideSidebar}/>
            <SidebarLink title="신고 내역" icon="sad" route="/report-logs" isSubMenu="true" onClick={this.hideSidebar}/>
          </SidebarCategory>
          <SidebarCategory title="사용자 관리" icon="users">
            <SidebarLink title="사용자 관리" icon="users" route="/users" isSubMenu="true" onClick={this.hideSidebar}/>
            <SidebarLink title="사용자 관리 내역" icon="list" route="/user-audits" isSubMenu="true" onClick={this.hideSidebar}/>
          </SidebarCategory>
          <SidebarCategory title="인증 서버" icon="lock">
            <SidebarLink title="OAuth 애플리케이션" icon="lock" route="/oauth-clients" isSubMenu="true" onClick={this.hideSidebar}/>
          </SidebarCategory>
          <SidebarCategory title="시스템 관리" icon="cog">
            <SidebarLink title="관리자 권한" icon="users" route="/admin-access" isSubMenu="true" onClick={this.hideSidebar}/>
            {hasServerManagement && <SidebarLink title="게임 서버 관리" icon="cog" route="/server-management" isSubMenu="true" onClick={this.hideSidebar}/>}
            {hasApiAccess && <SidebarLink title="API 문서" icon="book" route="/api-docs" isSubMenu="true" onClick={this.hideSidebar}/>}
          </SidebarCategory>
          <SidebarCategory title="우편함 관리" icon="envelope">
            <SidebarLink title="우편함 관리" icon="envelope" route="/mailbox" isSubMenu="true" onClick={this.hideSidebar}/>
            <SidebarLink title="우편함 관리 내역" icon="list" route="/mailbox-audits" isSubMenu="true" onClick={this.hideSidebar}/>
          </SidebarCategory>
          <SidebarCategory title="행사 관리" icon="calendar">
            <SidebarLink title="행사 관리" icon="calendar" route="/events" isSubMenu="true" onClick={this.hideSidebar}/>
            <SidebarLink title="행사 관리 내역" icon="list" route="/event-audits" isSubMenu="true" onClick={this.hideSidebar}/>
          </SidebarCategory>
          <SidebarCategory title="단어 관리" icon="database">
            <SidebarLink title="한국어 단어 관리" icon="database" route="/words-ko" isSubMenu="true" onClick={this.hideSidebar}/>
            <SidebarLink title="영어 단어 관리" icon="database" route="/words-en" isSubMenu="true" onClick={this.hideSidebar}/>
            <SidebarLink title="한국어 단어 관리 내역" icon="list" route="/word-audits-ko" isSubMenu="true" onClick={this.hideSidebar}/>
            <SidebarLink title="영어 단어 관리 내역" icon="list" route="/word-audits-en" isSubMenu="true" onClick={this.hideSidebar}/>
            <SidebarLink title="십자말풀이 관리" icon="list" route="/crosswords" isSubMenu="true" onClick={this.hideSidebar}/>
            <SidebarLink title="주제 프리셋 관리" icon="layers" route="/theme-presets" isSubMenu="true" onClick={this.hideSidebar}/>
            <SidebarLink title="한국어 단어 오타 검사" icon="magnifier" route="/word-spellcheck" isSubMenu="true" onClick={this.hideSidebar}/>
          </SidebarCategory>
          <SidebarCategory title="상점 관리" icon="store">
            <SidebarLink title="상점 아이템 관리" icon="store" route="/shop" isSubMenu="true" onClick={this.hideSidebar}/>
            <SidebarLink title="상점 관리 내역" icon="list" route="/shop-audits" isSubMenu="true" onClick={this.hideSidebar}/>
          </SidebarCategory>
          <SidebarCategory title="도움말" icon="question-circle">
            <button type="button" className="sidebar__link" route="/kb/moderation" onClick={this.hideSidebar}>
              <p className="sidebar__link-title">운영팀 도움말</p>
            </button>
            <button type="button" className="sidebar__link" route="/kb/word" onClick={this.hideSidebar}>
              <p className="sidebar__link-title">단어팀 도움말</p>
            </button>
          </SidebarCategory>
        </ul>
        <SidebarOutLink title="끄투리오"
                        link="https://kkutu.io"/>
        <SidebarOutLink title="끄투리오 노션"
                        link="https://www.notion.so/kkutuio/e34de413ed6841359c9ba3c24965bd31"/>
        <SidebarOutLink title="끄투리오 사용자 규정"
                        link="https://kkutuio.notion.site/aa92028fc4284743892cf4e26755bf6f"/>
        <SidebarOutLink title="끄투리오 디스코드"
                        link="https://discord.gg/hzZa2YsfZQ"/>
        <SidebarOutLink title="끄투리오 공식카페"
                        link="https://cafe.naver.com/kkutuio"/>
      </div>
    );
  }
}

export default connect(state => ({ profile: state.user.user }))(SidebarContent);
